import { throwErrorMessage } from 'dashboard/store/utils/api';
import ConversationApi from '../../../../api/inbox/conversation';
import mutationTypes from '../../../mutation-types';

const isReadOnlyObserver = rootGetters =>
  rootGetters?.getCurrentUser?.flysport_read_only_observer === true;

export default {
  markMessagesRead: async ({ commit, state, rootGetters = {} }, data) => {
    if (isReadOnlyObserver(rootGetters)) return false;

    const snapshot = () => {
      const chat = state?.allConversations?.find(item => item.id === data.id);
      return JSON.stringify([
        chat?.agent_last_seen_at,
        chat?.unread_count,
        chat?.messages?.map(message => message.id),
      ]);
    };
    const beforeRequest = snapshot();
    try {
      const {
        data: { id, agent_last_seen_at: lastSeen, unread_count: unreadCount },
      } = await ConversationApi.markMessageRead(data);
      // A websocket event or a deliberate unread action can supersede this response.
      if (snapshot() === beforeRequest) {
        commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
          id,
          lastSeen,
          unreadCount,
          monotonic: true,
        });
        return { lastSeen };
      }
      return false;
    } catch (error) {
      return false;
    }
  },

  markMessagesUnread: async ({ commit }, { id }) => {
    try {
      const {
        data: { agent_last_seen_at: lastSeen, unread_count: unreadCount },
      } = await ConversationApi.markMessagesUnread({ id });
      commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
        id,
        lastSeen,
        unreadCount,
      });
    } catch (error) {
      throwErrorMessage(error);
    }
  },
};
